const inputType = {
    STRING : 0,

    NUMBER : 1,

    BOOLEAN : 2,

    BUTTON : 3,

    RADIO_BUTTON : 4,

    DROP_DOWN : 5,

    CHECK_BOX : 6,

    MULTI_SELECT_SET : 7

};

angular.module('gw-um-j2js')
    .constant('inputType', inputType);